import React, { useEffect, useState } from "react";
import CaseService from "../../../services/CaseService";
import { getErrorMessage } from "../../../helpers/functions";
import { useSnackbar } from "notistack";
import { Autocomplete } from "@material-ui/lab";
import { makeStyles, Popper } from "@material-ui/core";
import styled from "styled-components";
import theme from "../../../assets/theme";
import COLORS from "../../../assets/Colors";
import { CustomInputField } from "../../common/FormInputs";

const useStyles = makeStyles((theme) => ({
  listbox: {
    color: "#293461",
    fontFamily: "openSans-SemiBold, sans-serif",
    fontSize: "16px",
    backgroundColor: "#ffffff",
    border: "2px solid #8B008B",
  },
  noOptions: {
    fontFamily: "openSans-SemiBold, sans-serif",
    color: "#8294a5",
  },
  customTooltip: {
    backgroundColor: "#D9EAFD",
    color: "#293461",
    fontSize: "12px",
    borderRadius: "8px",
    fontFamily: "openSans-SemiBold, sans-serif",
  },
  customArrow: {
    color: "#D9EAFD",
  },
}));

const CustomPopper = (props) => {
  return (
    <Popper
      {...props}
      placement="bottom-start"
      style={{ width: "380px", height: "5px" }}
    />
  );
};

const DocChangeType = ({ rowData, documentTypes }) => {
  const { enqueueSnackbar } = useSnackbar();
  let docId = rowData?.id;
  let caseId = rowData?.entityId;
  const classes = useStyles();
  const [selectedValue, setSelectedValue] = useState(null);

  const changeDocType = async (category, value) => {
    try {
      const payload = {
        uploadType: value,
        category: category,
      };
      const res = await CaseService.changeDocType(payload, caseId, docId);
      if (res) {
        enqueueSnackbar("Document Type Changed Successfully", {
          variant: "success",
        });
      }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
    }
  };

  const fetchInitialValue = () => {
    // Simulate fetching initial value (e.g., from DB)
    return { category: rowData?.url?.category, name: rowData?.url?.uploadType };
  };

  useEffect(() => {
    // Set initial value
    const initialValue = fetchInitialValue();
    setSelectedValue(initialValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowData?.url]);

  return (
    <Container className="input-select">
      <Autocomplete
        id="size-small-outlined"
        size="small"
        classes={{ noOptions: classes.noOptions }}
        value={selectedValue}
        onChange={(event, newValue) => {
          setSelectedValue(newValue);
          changeDocType(newValue?.category, newValue?.name);
        }}
        options={Object.entries(documentTypes).flatMap(([category, names]) =>
          names.map((name) => ({ category, name })),
        )}
        groupBy={(option) => option.category}
        getOptionLabel={(option) => option.name}
        renderInput={(params) => (
          <div ref={params.InputProps.ref}>
            <CustomInputField
              style={{ width: "150px" }}
              {...params}
              variant="outlined"
            />
          </div>
        )}
        popupIcon
        disableClearable
        renderGroup={(params) => (
          <div style={{ padding: "8px 0" }}>
            <div
              style={{
                padding: "10px 16px",
                fontWeight: "700",
                fontSize: "11px",
                color: "#0f766e",
                textTransform: "uppercase",
                letterSpacing: "0.8px",
                backgroundColor: "#f0fdf4",
                borderRadius: "6px",
                margin: "4px 8px",
              }}
            >
              {params.group}
            </div>
            <div
              style={{
                padding: "4px 0",
                color: COLORS.COLOR_DARK,
                fontFamily: theme.fonts.primaryFontSemiBold,
              }}
            >
              {params.children}
            </div>
          </div>
        )}
        noOptionsText={
          <div variant="body2" color="textSecondary">
            No Document type found
          </div>
        }
        PopperComponent={CustomPopper}
      />
    </Container>
  );
};

export default DocChangeType;

export const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  @media ${theme?.breakpoints?.sm_up} {
    width: auto;
  }
`;
